<form [formGroup]='healthInsuranceForm' id='{{formGroupName}}' (ngSubmit)='onSubmit()'>

	<div class='step-title service-title' i18n>Health Insurance</div>
	<div class='step-description' i18n>Avoid being uninsured after your move. Compare plans today</div>

	<div class='health-insurance-fields'>
		<div class='form-control select-no-label'>
			<label for="countryOfOrigin" i18n>Nationality</label>
			<mat-form-field>
				<select matNativeControl formControlName='countryOfOrigin' id="countryOfOrigin">
					<option *ngIf="!healthInsuranceForm.controls['countryOfOrigin'].value" [ngValue]="null" selected>- Select -</option>
					<optgroup *ngIf='formService.popularCountries && formService.popularCountries.length' i18n-label='@@labelPopularCountries' label='Popular'>
						<option *ngFor='let country of formService.popularCountries' [value]='country.country_code'>
							{{country.country}}
						</option>
					</optgroup>
					<optgroup i18n-label='@@labelAllCountries' label='All countries'>
						<option *ngFor='let country of formService.countries' [value]='country.country_code'>
							{{country.country}}
						</option>
					</optgroup>
				</select>
			</mat-form-field>
		</div>

		<div class="form-fields">
			<div class='form-control select-no-label'>
				<label for="coverageLength" i18n>Length of coverage</label>
				<mat-form-field appearance="outline" class="full-width">
					<mat-select formControlName='coverageLength' id="coverageLength">
						<mat-option value='less_than_one_year' i18n>Less than one year</mat-option>
						<mat-option value='more_than_one_year' i18n>More than one year</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class='form-control select-no-label'>
				<label for="age" i18n>How old are you?</label>
				<mat-form-field appearance="outline" class="full-width">
					<input matInput type="number" formControlName='age' id="age" min="18">
				</mat-form-field>
			</div>
		</div>

		<div class='form-control less-more-input'>
			<label for="dependants" i18n>How many family members included?</label>
			<div class='dependants-input-group'>
				<button type='button' (click)='decrementDependants()'>-</button>
				<span id="dependants">{{ healthInsuranceForm.get('dependants')?.value || 0 }}</span>
				<button type='button' (click)='incrementDependants()'>+</button>
			</div>
		</div>
	</div>

	<!-- Mobile Navigation Buttons -->
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backThirdParty()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit' type='submit'>
				<ng-container *ngIf='formService.isLastThirdPartyStep()' i18n='buttonSaveSelection'>Save</ng-container>
				<ng-container *ngIf='!formService.isLastThirdPartyStep()' i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>
</form>
